import React from "react";
import { Grid, Icon } from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import { confirmAlert } from "react-confirm-alert";
import { TranslateContext } from "../TranslateContext";

const ExitInformationDetails =({item:{exitInfo,remarks,id},deleteData,updateData,saveData,disabled,validateExitInfo,exitInfoList}) =>{
 
  const translate = React.useContext(TranslateContext).translate
  
  const description=React.useMemo(()=>(exitInfo ? exitInfoList.find(c=>c.value==exitInfo)?.text : ''),[exitInfoList,exitInfo])
  return (
  
      <Grid.Row>
        <Grid.Column width="5" className="divFormFeild border-bottom b-rw-0">
          <DropDown
            id={`exitInfo-${id}`}
            className="field-bg dropdown100 addInfoCode"
            labelClass="text-none"
            label={translate("EXIT_INFORMATION", {ns:["default", "header"]})}
            boxNumber="44"
            isLabel={true}
            data={exitInfoList}
            displayType={false}
            isDisabled={disabled}
            clearable
            value={exitInfo || ''}
            onChange={(value) => {
              if(validateExitInfo(value,id)){
                confirmAlert({
                  message: "Only 1 of type AAZ is allowed",
                  buttons: [{label: 'OK'}]
                });
                 
              }
              else{
             
              saveData({id,exitInfo:value})
              updateData(id,{exitInfo:value?.trim()})
            }
            }
            }
           
          />
        </Grid.Column>

        <Grid.Column width="5" className="divFormFeild  border-bottom  b-rw-0">
          <InputField
            isLabel={false}
            id={`exitDesc-${id}`}
            type="text"
            label={translate("EXIT_DESCRIPTION", {ns:["default", "header"]})}
            value={description}
            className="field-bg"
            clearInput={false}
            disabled={true}
           // onChange={(value) =>updateData(id,{description:value})}
          //  onBlur={(value) =>saveData({id,description})}
          />
        </Grid.Column>
      
   
        <Grid.Column width="5" className="divFormFeild border-bottom">
          <InputField
            isLabel={false}
            id={`remarks-${id}`}
            type="text"
            value={remarks}
            label={translate("REMARKS", {ns:["default", "header"]})}
            className="field-bg"
            onChange={(value) =>updateData(id, {remarks: value})}
            onBlur={(value) =>saveData({id, remarks:remarks || " "})}
            isDisabled={disabled}
          />
        </Grid.Column>
        <Grid.Column width="1" className="icon-delete-add-info">
           <Icon disabled={disabled} name="trash alternate outline" id={`exitInfo-delete-${id}`} onClick={() =>deleteData(id)} />
           
        </Grid.Column>
      </Grid.Row>
   
  );
}

export default React.memo(ExitInformationDetails)
